import * as React from 'react';

function ZezamiiGatewaysIcon({ color = '#545454', ...props }) {
	return (
		<svg width={18} height={18} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<path
				d='M8.19531 9.60024C8.61225 10.3315 8.83151 11.1588 8.83151 12.0006C8.83151 12.8424 8.61225 13.6697 8.19531 14.401M11.3164 8.22387C11.9681 9.37591 12.3105 10.677 12.3105 12.0005C12.3105 13.3241 11.9681 14.6252 11.3164 15.7772M14.431 6.84766C15.3296 8.41614 15.8029 10.1921 15.804 11.9998C15.8052 13.8074 15.3341 15.584 14.4375 17.1536'
				stroke={color}
				stroke-width='2'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
			<rect x='16.0391' y='0.994141' width='7.08392' height='7.64024' rx='1.5' fill={color} />
			<path
				d='M17.8292 6.99414V6.41918L20.1156 3.21101H17.8247V2.41232H21.3326V2.98729L19.044 6.19545H21.3371V6.99414H17.8292Z'
				fill={color === 'white' ? '#545454' : 'white'}
			/>
		</svg>
	);
}

export default ZezamiiGatewaysIcon;
